import { useCallback, useState } from 'react';
import { v4 as uuid } from 'uuid';

type MenuRegistration = {
  id: string;
  close: () => void;
};

let currentOpened: MenuRegistration | null = null;

const registerOpenMenu = (id: string, close: () => void) => {
  const newEntry: MenuRegistration = { id, close };
  if (currentOpened?.id !== newEntry.id) currentOpened?.close();
  currentOpened = newEntry;
  return () => {
    if (currentOpened?.id === newEntry.id) currentOpened = null;
  };
};

/**
 * Hook to register a root menu instance as opened. Will call current root menu instance's close function if it exists.
 * @returns An object with a register function to register a root menu instance when it opens.
 */
export const useMenuRegistration = () => {
  const [id] = useState(() => uuid());
  const register = useCallback(
    (close: () => void) => registerOpenMenu(id, close),
    [id],
  );

  return { register };
};
